import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    Box,
    Typography,
    Paper,
    Grid,
    Avatar,
    Divider,
    Button,
    Chip,
    Stack,
    TextField,
    MenuItem,
} from "@mui/material";
import {
    Person,
    Phone,
    Work,
    Description,
    Paid,
    Security,
    ArrowBack,
    Edit,
    Save,
    Close,
} from "@mui/icons-material";
import { useParams, useNavigate } from "react-router-dom";
import Autocomplete from "@mui/material/Autocomplete";

import countries from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";

countries.registerLocale(enLocale);

const nationalityOptions = Object.values(
    countries.getNames("en", { select: "official" })
);
const API_URL = "https://api.hr-ebnhaian.cloud/api/v1/doctors";

/* =========================
   HELPERS
========================= */
const formatDate = (d) =>
    d ? new Date(d).toISOString().substring(0, 10) : "";

const viewDate = (d) =>
    d ? new Date(d).toLocaleDateString() : "-";

const expiryStatus = (d) => {
    if (!d) return null;
    const diff = Math.ceil((new Date(d) - new Date()) / 86400000);
    if (diff < 0) return { label: "EXPIRED", color: "error" };
    if (diff <= 60) return { label: `EXPIRING (${diff} days)`, color: "warning" };
    return null;
};

/* =========================
   SECTION
========================= */
const Section = ({ title, icon, children }) => (
    <Paper sx={{ p: 3, mb: 3, borderLeft: "6px solid #1976d2" }}>
        <Stack direction="row" spacing={1} alignItems="center" mb={2}>
            {icon}
            <Typography variant="h6" fontWeight="bold">
                {title}
            </Typography>
        </Stack>
        <Divider sx={{ mb: 2 }} />
        {children}
    </Paper>
);

function DoctorDetails() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [doctor, setDoctor] = useState(null);
    const [form, setForm] = useState({});
    const [isEdit, setIsEdit] = useState(false);
    const [departments, setDepartments] = useState([]);
    /* =========================
       FETCH
    ========================= */
    // useEffect(() => {
    //     axios.get(`${API_URL}/${id}`).then((res) => {
    //         setDoctor(res.data.data);
    //         setForm(res.data.data);
    //     });
    // }, [id]);
    // useEffect(() => {
    //     axios.get(`${API_URL}/${id}`).then((res) => {

    //         const d = res.data.data;

    //         setDoctor(d);

    //         setForm({
    //             ...d,
    //             center: typeof d.center === "object" ? d.center._id : d.center,
    //             department: typeof d.department === "object" ? d.department._id : d.department
    //         });

    //     });
    // }, [id]);
    useEffect(() => {

        const loadData = async () => {

            const [doctorRes, depRes] = await Promise.all([
                axios.get(`${API_URL}/${id}`),
                axios.get("https://api.hr-ebnhaian.cloud/api/v1/departments")
            ]);

            const d = doctorRes.data.data;

            setDoctor(d);

            setForm({
                ...d,
                center: typeof d.center === "object" ? d.center._id : d.center,
                department: typeof d.department === "object" ? d.department._id : d.department
            });

            setDepartments(depRes.data.data || []);

        };

        loadData();

    }, [id]);
    /* =========================
       HANDLERS
    ========================= */
    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleNestedChange = (path, value) => {
        setForm((prev) => {
            const copy = structuredClone(prev);
            let ref = copy;
            const keys = path.split(".");
            keys.slice(0, -1).forEach((k) => (ref = ref[k]));
            ref[keys.at(-1)] = value;
            return copy;
        });
    };

    const handleFile = (name, file) => {
        setForm({ ...form, [name]: file });
    };

    // const handleSave = async () => {
    //     const fd = new FormData();

    //     const append = (obj, parent = "") => {
    //         Object.entries(obj || {}).forEach(([k, v]) => {
    //             const key = parent ? `${parent}.${k}` : k;
    //             if (v instanceof File) fd.append(k, v);
    //             else if (Array.isArray(v) || typeof v === "object") append(v, key);
    //             else if (v !== null && v !== undefined) fd.append(key, v);
    //         });
    //     };

    //     append(form);

    //     await axios.put(`${API_URL}/${id}`, fd, {
    //         headers: { "Content-Type": "multipart/form-data" },
    //     });

    //     const refreshed = await axios.get(`${API_URL}/${id}`);
    //     setDoctor(refreshed.data.data);
    //     setForm(refreshed.data.data);
    //     setIsEdit(false);
    // };
    const handleSave = async () => {

        const fd = new FormData();

        const append = (obj, parent = "") => {

            Object.entries(obj || {}).forEach(([k, v]) => {

                const key = parent ? `${parent}.${k}` : k;

                // FIX center
                if (k === "center") {
                    const val = typeof v === "object" ? v?._id : v;
                    fd.append("center", val);
                    return;
                }

                // FIX department
                if (k === "department") {
                    const val = typeof v === "object" ? v?._id : v;
                    fd.append("department", val);
                    return;
                }

                if (v instanceof File) {
                    fd.append(k, v);
                }

                else if (Array.isArray(v) || typeof v === "object") {
                    append(v, key);
                }

                else if (v !== null && v !== undefined) {
                    fd.append(key, v);
                }

            });

        };

        append(form);

        // DEBUG
        console.log("========== FORM ==========");
        console.log(form);

        console.log("CENTER SENT:", form.center);
        console.log("DEPARTMENT SENT:", form.department);

        console.log("========== FORM DATA ==========");
        for (let pair of fd.entries()) {
            console.log(pair[0], pair[1]);
        }

        await axios.put(`${API_URL}/${id}`, fd, {
            headers: { "Content-Type": "multipart/form-data" },
        });

        const refreshed = await axios.get(`${API_URL}/${id}`);

        setDoctor(refreshed.data.data);
        setForm(refreshed.data.data);
        setIsEdit(false);
    };
    if (!doctor) return <Typography p={3}>Loading...</Typography>;
    console.log("MEDICAL LICENSES:", doctor.medicalLicenses);

    return (
        <Box
            sx={{
                background: "#f4f6fa",
                minHeight: "100vh",
                pt: 8,   // 👈 مسافة من الأعلى
                px: 3,
                pb: 3,
            }}
        >
            {/* HEADER */}
            <Stack direction="row" spacing={2} mb={3}>
                <Button
                    startIcon={<ArrowBack />}
                    variant="outlined"
                    onClick={() => navigate(-1)}
                >
                    Back
                </Button>

                {!isEdit ? (
                    <Button
                        startIcon={<Edit />}
                        variant="contained"
                        onClick={() => setIsEdit(true)}
                    >
                        Edit Doctor
                    </Button>
                ) : (
                    <>
                        <Button
                            startIcon={<Save />}
                            variant="contained"
                            color="success"
                            onClick={handleSave}
                        >
                            Save All
                        </Button>
                        <Button
                            startIcon={<Close />}
                            variant="outlined"
                            color="error"
                            onClick={() => {
                                setForm(doctor);
                                setIsEdit(false);
                            }}
                        >
                            Cancel
                        </Button>
                    </>
                )}
            </Stack>

            {/* ================= BASIC ================= */}
            <Section title="Basic Information" icon={<Person />}>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={3} textAlign="center">
                        <Avatar
                            src={
                                doctor.profileImage
                                    ? `https://api.hr-ebnhaian.cloud${doctor.profileImage}`
                                    : "/default.jpg"
                            }

                            sx={{ width: 130, height: 130, mx: "auto" }}
                        />
                        {isEdit && (
                            <Button component="label" size="small" sx={{ mt: 1 }}>
                                Change Image
                                <input
                                    hidden
                                    type="file"
                                    onChange={(e) =>
                                        handleFile("profileImage", e.target.files[0])
                                    }
                                />
                            </Button>
                        )}
                    </Grid>

                    <Grid item xs={12} md={9}>
                        {isEdit ? (
                            <>
                                <TextField
                                    label="First Name"
                                    name="firstName"
                                    value={form.firstName || ""}
                                    onChange={handleChange}
                                    fullWidth
                                    sx={{ mb: 2 }}
                                />
                                <TextField
                                    label="Last Name"
                                    name="lastName"
                                    value={form.lastName || ""}
                                    onChange={handleChange}
                                    fullWidth
                                    sx={{ mb: 2 }}
                                />
                                <TextField
                                    label="Father Name"
                                    name="fatherName"
                                    value={form.fatherName || ""}
                                    onChange={handleChange}
                                    fullWidth
                                />
                            </>
                        ) : (
                            <>
                                <Typography>
                                    <b>Name:</b> {doctor.firstName} {doctor.lastName}
                                </Typography>
                                <Typography>
                                    <b>Father Name:</b> {doctor.fatherName || "-"}
                                </Typography>
                            </>
                        )}
                    </Grid>
                </Grid>
            </Section>

            {/* ================= CONTACT ================= */}
            <Section title="Contact Information" icon={<Phone />}>
                {isEdit ? (
                    <>
                        <TextField
                            label="Phone"
                            name="phone"
                            value={form.phone || ""}
                            onChange={handleChange}
                            fullWidth
                            sx={{ mb: 2 }}
                        />
                        <TextField
                            label="Email"
                            name="email"
                            value={form.email || ""}
                            onChange={handleChange}
                            fullWidth
                            sx={{ mb: 2 }}
                        />
                        <Autocomplete
                            options={nationalityOptions}
                            value={form.nationality || null}
                            onChange={(e, value) =>
                                setForm({ ...form, nationality: value || "" })
                            }
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Nationality"
                                    fullWidth
                                    sx={{ mb: 2 }}
                                />
                            )}
                        />
                        <TextField
                            label="Address"
                            name="address"
                            value={form.address || ""}
                            onChange={handleChange}
                            fullWidth
                        />
                    </>
                ) : (
                    <>
                        <>
                            <Typography><b>Phone:</b> {doctor.phone}</Typography>
                            <Typography><b>Email:</b> {doctor.email || "-"}</Typography>
                            <Typography><b>Nationality:</b> {doctor.nationality || "-"}</Typography>
                            <Typography><b>Address:</b> {doctor.address || "-"}</Typography>
                        </>
                    </>
                )}
            </Section>

            {/* ================= Medical Licenses ================= */}

            <Section title="Medical Licenses" icon={<Security />}>
                {(doctor.medicalLicenses || []).map((lic, i) => {
                    const exp = expiryStatus(lic.expiryDate);

                    return (
                        <Paper key={i} sx={{ p: 2, mb: 2 }}>
                            <Stack direction="row" justifyContent="space-between">
                                <Typography fontWeight="bold">
                                    {lic.authority} – {lic.licenseNumber}
                                </Typography>
                                {exp && <Chip label={exp.label} color={exp.color} />}
                            </Stack>

                            {isEdit ? (
                                <>
                                    <TextField
                                        label="License Number"
                                        value={lic.licenseNumber}
                                        onChange={(e) =>
                                            handleNestedChange(
                                                `medicalLicenses.${i}.licenseNumber`,
                                                e.target.value
                                            )
                                        }
                                        fullWidth
                                        sx={{ mb: 1 }}
                                    />

                                    <TextField
                                        type="date"
                                        label="Expiry Date"
                                        InputLabelProps={{ shrink: true }}
                                        value={formatDate(lic.expiryDate)}
                                        onChange={(e) =>
                                            handleNestedChange(
                                                `medicalLicenses.${i}.expiryDate`,
                                                e.target.value
                                            )
                                        }
                                        fullWidth
                                    />

                                    <Button component="label" size="small" sx={{ mt: 1 }}>
                                        Upload License File
                                        <input
                                            hidden
                                            type="file"
                                            onChange={(e) =>
                                                handleFile(`medicalLicenseFile_${i}`, e.target.files[0])
                                            }
                                        />
                                    </Button>
                                </>
                            ) : (
                                <>
                                    <Typography>Issue Date: {viewDate(lic.issueDate)}</Typography>
                                    <Typography>Expiry Date: {viewDate(lic.expiryDate)}</Typography>
                                    <Typography>Status: {lic.status}</Typography>

                                    {lic.file && (
                                        <Button
                                            href={`https://api.hr-ebnhaian.cloud${lic.file}`}
                                            target="_blank"
                                            size="small"
                                        >
                                            View License
                                        </Button>

                                    )}
                                </>
                            )}
                        </Paper>
                    );
                })}
            </Section>



            {/* ================= Contract ================= */}

            <Section title="Contract" icon={<Description />}>
                {isEdit ? (
                    <>
                        <TextField
                            select
                            label="Contract Type"
                            value={form.contract?.type || "FULL_TIME"}
                            onChange={(e) =>
                                handleNestedChange("contract.type", e.target.value)
                            }
                            fullWidth
                            sx={{ mb: 2 }}
                        >
                            <MenuItem value="FULL_TIME">Full Time</MenuItem>
                            <MenuItem value="PART_TIME">Part Time</MenuItem>
                            <MenuItem value="VISITING">Visiting</MenuItem>
                        </TextField>

                        <TextField
                            type="date"
                            label="Contract Start"
                            InputLabelProps={{ shrink: true }}
                            value={formatDate(form.contract?.startDate)}
                            onChange={(e) =>
                                handleNestedChange("contract.startDate", e.target.value)
                            }
                            fullWidth
                            sx={{ mb: 2 }}
                        />

                        <Button component="label" size="small">
                            Upload Contract File
                            <input
                                hidden
                                type="file"
                                onChange={(e) =>
                                    handleFile("contractFile", e.target.files[0])
                                }
                            />
                        </Button>
                    </>
                ) : (
                    <>
                        <Typography><b>Type:</b> {doctor.contract?.type}</Typography>
                        <Typography><b>Start:</b> {viewDate(doctor.contract?.startDate)}</Typography>
                        <Typography><b>End:</b> {viewDate(doctor.contract?.endDate)}</Typography>

                        {doctor.contract?.file && (
                            <Button
                                href={`https://api.hr-ebnhaian.cloud/uploads/doctors/${doctor.contract.file.split("/").pop()}`}
                                target="_blank"
                                size="small"
                                sx={{ mt: 1 }}
                            >
                                View Contract
                            </Button>
                        )}

                    </>
                )}
            </Section>



            {/* ================= Commission / Finance ================= */}

            <Section title="Commission / Finance" icon={<Paid />}>
                {isEdit ? (
                    <>
                        <TextField
                            select
                            label="Commission Type"
                            value={form.commission?.type || "PERCENTAGE"}
                            onChange={(e) =>
                                handleNestedChange("commission.type", e.target.value)
                            }
                            fullWidth
                            sx={{ mb: 2 }}
                        >
                            <MenuItem value="PERCENTAGE">Percentage</MenuItem>
                            <MenuItem value="FIXED">Fixed</MenuItem>
                        </TextField>

                        <TextField
                            label="Commission Value"
                            type="number"
                            value={form.commission?.value || ""}
                            onChange={(e) =>
                                handleNestedChange("commission.value", e.target.value)
                            }
                            fullWidth
                        />
                    </>
                ) : (
                    <>
                        <Typography><b>Type:</b> {doctor.commission?.type}</Typography>
                        <Typography><b>Value:</b> {doctor.commission?.value}</Typography>
                        <Typography><b>Apply On:</b> {doctor.commission?.applyOn}</Typography>
                    </>
                )}
            </Section>

            {/* ================= Professional Information ================= */}
            <Section title="Professional Information" icon={<Work />}>
                {isEdit ? (
                    <>
                        <TextField
                            label="Specialization"
                            value={form.specialization || ""}
                            onChange={(e) =>
                                setForm({ ...form, specialization: e.target.value })
                            }
                            fullWidth
                            sx={{ mb: 2 }}
                        />
                        <TextField
                            select
                            label="Department"
                            value={form.department || ""}
                            onChange={(e) =>
                                setForm({ ...form, department: e.target.value })
                            }
                            fullWidth
                            sx={{ mb: 2 }}
                        >
                            {departments.map((d) => (
                                <MenuItem key={d._id} value={d._id}>
                                    {d.name}
                                </MenuItem>
                            ))}
                        </TextField>
                        {/* <TextField
                            label="Department"
                            value={form.department || ""}
                            onChange={(e) =>
                                setForm({ ...form, department: e.target.value })
                            }
                            fullWidth
                            sx={{ mb: 2 }}
                        />

                        <TextField
                            label="Nationality"
                            value={form.nationality || ""}
                            onChange={(e) =>
                                setForm({ ...form, nationality: e.target.value })
                            }
                            fullWidth
                            sx={{ mb: 2 }}
                        />

                        <TextField
                            label="Basic Salary"
                            type="number"
                            value={form.salary?.basicSalary || ""}
                            onChange={(e) =>
                                handleNestedChange("salary.basicSalary", e.target.value)
                            }
                            fullWidth
                            sx={{ mb: 2 }}
                        /> */}

                        <TextField
                            type="date"
                            label="Start Date"
                            InputLabelProps={{ shrink: true }}
                            value={formatDate(form.startDate)}
                            onChange={(e) =>
                                setForm({ ...form, startDate: e.target.value })
                            }
                            fullWidth
                            sx={{ mb: 2 }}
                        />

                        <TextField
                            type="date"
                            label="End Date"
                            InputLabelProps={{ shrink: true }}
                            value={formatDate(form.endDate)}
                            onChange={(e) =>
                                setForm({ ...form, endDate: e.target.value })
                            }
                            fullWidth
                        />
                    </>
                ) : (
                    <>
                        <Typography><b>Center:</b> {doctor.center?.name}</Typography>
                        <Typography><b>Department:</b> {doctor.department?.name}</Typography>
                        <Typography><b>Specialization:</b> {doctor.specialization}</Typography>
                        <Typography><b>Start Date:</b> {viewDate(doctor.startDate)}</Typography>
                        <Typography><b>End Date:</b> {viewDate(doctor.endDate)}</Typography>
                        <Typography><b>Status:</b> {doctor.status}</Typography>
                        <Typography><b>Role Type:</b> {doctor.roleType}</Typography>
                    </>
                )}
            </Section>




            {/* ================= DOCUMENTS ================= */}
            <Section title="Documents" icon={<Description />}>
                {["passport", "visa", "emiratesId"].map((k) => {
                    const d = doctor.documents?.[k];
                    if (!d) return null;
                    const exp = expiryStatus(d.expiryDate);

                    return (
                        <Paper key={k} sx={{ p: 2, mb: 2 }}>
                            <Stack direction="row" justifyContent="space-between">
                                <Typography fontWeight="bold">{k.toUpperCase()}</Typography>
                                {exp && <Chip label={exp.label} color={exp.color} />}
                            </Stack>

                            {isEdit ? (
                                <>
                                    <TextField
                                        label="Number"
                                        value={form.documents?.[k]?.number || ""}
                                        onChange={(e) =>
                                            handleNestedChange(
                                                `documents.${k}.number`,
                                                e.target.value
                                            )
                                        }
                                        fullWidth
                                        sx={{ mb: 1 }}
                                    />
                                    <TextField
                                        type="date"
                                        label="Expiry Date"
                                        InputLabelProps={{ shrink: true }}
                                        value={formatDate(form.documents?.[k]?.expiryDate)}
                                        onChange={(e) =>
                                            handleNestedChange(
                                                `documents.${k}.expiryDate`,
                                                e.target.value
                                            )
                                        }
                                        fullWidth
                                    />
                                    <Button component="label" size="small" sx={{ mt: 1 }}>
                                        Upload File
                                        <input
                                            hidden
                                            type="file"
                                            onChange={(e) =>
                                                handleFile(`${k}File`, e.target.files[0])
                                            }
                                        />
                                    </Button>
                                </>
                            ) : (
                                <>
                                    <Typography>Number: {d.number}</Typography>
                                    <Typography>Expiry: {viewDate(d.expiryDate)}</Typography>
                                    {d.file && (
                                        <Button
                                            href={`https://api.hr-ebnhaian.cloud${d.file}`}
                                            target="_blank"
                                            size="small"
                                        >
                                            View File
                                        </Button>

                                    )}
                                </>
                            )}
                        </Paper>
                    );
                })}
            </Section>
            {/* ================= Notes ================= */}
            <Section title="Notes" icon={<Description />}>
                {isEdit ? (
                    <TextField
                        multiline
                        minRows={4}
                        value={form.notes || ""}
                        onChange={(e) =>
                            setForm({ ...form, notes: e.target.value })
                        }
                        fullWidth
                    />
                ) : (
                    <Typography>{doctor.notes || "-"}</Typography>
                )}
            </Section>

        </Box>
    );
}

export default DoctorDetails;
